module.exports = __webpack_public_path__ + "img/bg.b81259dc.jpg";